import { useStyles } from './styles'

import { FormWrapper } from './form-wrapper'
import { CameraProgression } from './progressions/camera-progression.component'
import { AddManuallyProgression } from './progressions/add-manually-progression.component'
import { AddMediaProgression } from './progressions/add-media-progression.component'
import { DetailsProgression } from './progressions/details-progression.component'
import { useCommonSettings } from 'src/hooks'
import { useEffect } from 'react'
import { Loader } from '../loader'
import { useNavigate } from 'react-router-dom'
import { joinAbsRoute } from 'src/common/utils'
import { ROUTES } from 'src/constants'

export const ScanToEarnComponent = () => {
  const classes = useStyles()
  const navigate = useNavigate()

  const { data: settings, isLoading } = useCommonSettings()

  useEffect(() => {
    if (settings) {
      if (!settings.scan_to_earn_enabled) {
        navigate(joinAbsRoute(ROUTES.USER, ROUTES.USER_DASHBOARD))
      }
    }
  }, [settings, isLoading])

  return (
    <>
      {settings && settings.scan_to_earn_enabled ? (
        <FormWrapper>
          <div className={classes.wrapperContainer}>
            <CameraProgression />
            <AddManuallyProgression />
            <AddMediaProgression />
            <DetailsProgression />
          </div>
        </FormWrapper>
      ) : (
        <Loader />
      )}
    </>
  )
}
